import { C } from "../constants";

export default function ProgressDots({ total, current }) {
  return (
    <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
      {Array.from({ length: total }).map((_, i) => (
        <div key={i} style={{
          width: i === current ? 18 : 8, height: 8, borderRadius: 4,
          background: i < current ? C.teal : i === current ? C.pink : C.dim,
          transition: "all 0.3s ease",
        }} />
      ))}
    </div>
  );
}
